import ReportLog from '../types/reports/reportLog';
import { Stack, Typography } from '@mui/material';
import { ReportTypeEnums } from '../types/referenceData/reportTypeEnums';


export const getReportTotalAmount = (reportLog:  ReportLog) => {
    switch (reportLog.reportTypeId) {
        case ReportTypeEnums.DonationReport:
        case ReportTypeEnums.LateContributionReport:
        case ReportTypeEnums.DepositReport:
            return (
                <Typography variant={'body2'} fontWeight={550}>
                    {reportLog.receiptTotal} 
                </Typography>
            );
        case ReportTypeEnums.DepositoryYearEndReport:
        case ReportTypeEnums.LpcPrePrimary:
        case ReportTypeEnums.LpcPreElection:
        case ReportTypeEnums.LpcYearEnd:
        case ReportTypeEnums.DissolutionReport:
        case ReportTypeEnums.TransitionOutReport:
        case ReportTypeEnums.TrainsitionInReport:
        case ReportTypeEnums.IEPACReport:
        case ReportTypeEnums.IEPACYearEndReport:
        case ReportTypeEnums.BallotQuestionYearEnd:
        case ReportTypeEnums.BankReport:
            return (
                <Stack spacing={0.5}>
                    <Typography variant={'body2'} fontWeight={550}>
                        {reportLog.receiptTotal} (<i>receipts</i>) 
                    </Typography>
                    <Typography variant={'body2'} fontWeight={550}>
                        {reportLog.expenditureTotal} (<i>expenditures</i>) 
                    </Typography>
                </Stack> 
            );
        case ReportTypeEnums.PayrollItemizationReport:
        case ReportTypeEnums.CreditCardReport:
        case ReportTypeEnums.SubvendorReport:
        case ReportTypeEnums.BankExpenditureItemizationReport:
        case ReportTypeEnums.ReimbursementReport:
            return (
                    <Typography variant={'body2'} fontWeight={550}>
                        {reportLog.expenditureTotal} 
                    </Typography>
                );
        default:
            return  (
                <Stack spacing={0.5}>
                    <Typography variant={'body2'} fontWeight={550}>
                        {reportLog.receiptTotal} (<i>receipts</i>) 
                    </Typography>
                    <Typography variant={'body2'} fontWeight={550}>
                        {reportLog.expenditureTotal} (<i>expenditures</i>) 
                    </Typography>
                </Stack> 
            );
    }
};